module.exports = __webpack_public_path__ + "img/Domus-logo.b2b97799.png";